module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor-graph-ff89ea77c8009dafc4966c0cca4df4dc.svg";